import React from 'react'
import gsap from "gsap";
import { useRef } from "react";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import './comingSoon.css'

gsap.registerPlugin(useGSAP);
gsap.registerPlugin(ScrollTrigger);

const ComingSoon = (props) => {
    // console.log('props', props)
    const two = useRef(null);
    const commingSoon = useRef(null);

    useGSAP(() => {
        const pTags = two.current.querySelectorAll("p");
        gsap.from(pTags, {
            scale: 1.2,
            opacity: 0,
            stagger: 1,
            duration: 1.9,
            ease: "elastic.out",
        });
    });

    useGSAP(() => {
        gsap.from(commingSoon.current, {
            opacity: 0,
            stagger: 0.1,
            delay: 0.2,
            duration: 10,
            ease: "elastic.out",
        });
    });

    return (
        <div>
            <div className="container">
                <div className="section">
                    <div ref={two}>
                        <p>{props.pageName}</p>
                        <h1 ref={commingSoon} className='comingSoon'>Coming soon...</h1>
                        {/* <p>soon...</p> */}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ComingSoon